<template>
   <div class="accordion__item" :class="{'accordion__item--expanded': visible}">
        <div class="accordion__trigger" @click="open" :rebuild="false">
            <span class="accordion__title-wrapper" v-if="customTags" v-html="title"></span>
            <span class="accordion__title-wrapper" v-else>{{ title }}</span>
            <span class="accordion__title-arrow">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 14" class="svg-arrow">
                    <path fill-rule="nonzero" d="M15.26 7.23H.22a.22.22 0 0 1 0-.44h15.05L8.84.37a.22.22 0 0 1 .3-.3l6.8 6.78c.06.06.08.15.05.23a.22.22 0 0 1-.06.08l-6.78 6.8a.22.22 0 0 1-.31-.31l6.42-6.42z"/>
                </svg>
            </span>
        </div><div class="accordion__wrapper">
            <div class="accordion__content"><slot /></div>
        </div>
    </div>
</template>
<script>
export default {
    props: ['title', 'customTags', 'rebuild'],
    inject: ['Accordion'],
    data() { return {index: undefined}; },
    computed: {
        visible() { return this.index === this.Accordion.active; }
    },
     methods: {
        open() { this.Accordion.active = this.visible ? null : this.index; },
    },
    created() { this.index = this.Accordion.count++ }
};
</script>



// WEBPACK FOOTER //
// resources/components/apps/accordion-item.vue